import { createContext, useContext, useMemo, type ReactNode } from "react";
import type { LifecycleActorRole } from "./lifecycleWorkspace";

type LifecycleShellState = {
  actorRole?: LifecycleActorRole;
  stageSummary?: any;
};

const LifecycleShellContext = createContext<LifecycleShellState | undefined>(undefined);

export function LifecycleShellProvider({ actorRole, stageSummary, children }: { actorRole?: LifecycleActorRole; stageSummary?: any; children: ReactNode }) {
  const value = useMemo(() => ({ actorRole, stageSummary }), [actorRole, stageSummary]);
  return <LifecycleShellContext.Provider value={value}>{children}</LifecycleShellContext.Provider>;
}

export function useLifecycleShell() {
  return useContext(LifecycleShellContext);
}
